const SlideImages = [
  {
    id: 1,
    imgUrl: "slide_image/suzy1.jpg",
  },
  {
    id: 2,
    imgUrl: "slide_image/suzy2.jpg",
  },
  {
    id: 3,
    imgUrl: "slide_image/suzy3.jpg",
  },
  {
    id: 4,
    imgUrl: "slide_image/suzy4.jpg",
  },
  {
    id: 5,
    imgUrl: "slide_image/suzy6.png",
  },
  {
    id: 6,
    imgUrl: "slide_image/suzy7.png",
  },
];
export default SlideImages;
